export const NavigationToggle = {
	state: (state = 'close') => {
		const navigationToggle = document.getElementById('navigation-toggle')
		
		if(state === 'active') {
			navigationToggle.classList.add('is-active')

			NavigationToggle.handlerLinks()
			return
		}

		navigationToggle.classList.remove('is-active')
	},

	handlerLinks: () => {
		const navigationToggleLinks = document.getElementById('navigation-toggle-links')
		const links = navigationToggleLinks.querySelectorAll('a')

		links.forEach( link => {
			link.addEventListener('click', () => {
				NavigationToggle.state('close')
			})
		})
	}
}